export const I18N = {
  en: {
    ARTCILES: "Articles",
    Official: "Official",
    Manager: "Manager",
    "Legal Reprentative": "Legal Reprentative",
    "Organization roles": "Organization roles",
    "Blog roles": "Blog roles",
    "Editor-in-chief": "Editor-in-chief",
    CHIEF_EDITOR: "CHIEF EDITOR",
    AUTHOR: "AUTHOR",
    REDACTOR: "REDACTOR",
    LEGAL_REPRESENTATIVE: "LEGAL REPRESENTATIVE",
    MANAGER: "MANAGER",
    OFFICIAL: "OFFICIAL",
    SHAREHOLDER: "SHAREHOLDER",
    QUALITY_MANAGER: "QUALITY MANAGER",
    EXTERNAL: "EXTERNAL",
    Mandated: "Mandated",
    Not_Mandated: "Not Mandated",
    Details: "Details",
    Join: "Join",
    Replay: "Replay",
    Purchase: "Purchase",
    "Possible to review the training for max 15 days after the date of the live":
      "Possible to review the training for max 15 days after the date of the live",
    Webinar: "Webinar",
    "In progress": "In progress",
    "Certificate included approved by": "Certificate included approved by",
    "En Live": "Live",
    see_version: "See version",
    atText: "at",
    publishedOn: "Published on",
    reading: "Reading",
    noOptions: "no options",
    sharedWith: "share with",
    share: "share",
    "En Replay": "En Replay",
    add: "Add",
    quote_text: "Insert quote text",
    quote_author: "Insert quote author",
  },
  fr: {
    ARTCILES: "Articles",
    Official: "Officiel",
    Manager: "Directeur",
    "Legal Reprentative": "Représentant légal",
    "Organization roles": "Rôles de l'organisation",
    "Blog roles": "Rôles du blog",
    "Editor-in-chief": "Éditeur en chef",
    CHIEF_EDITOR: "Rédacteur en chef",
    AUTHOR: "Auteur",
    REDACTOR: "Rédacteur",
    LEGAL_REPRESENTATIVE: "REPRÉSENTANT LÉGAL",
    MANAGER: "GÉRANT",
    OFFICIAL: "OFFICIEL",
    SHAREHOLDER: "ACTIONNAIRE",
    QUALITY_MANAGER: "RESPONSABLE QUALITÉ",
    EXTERNAL: "EXTERNE",
    Mandated: "Mandaté",
    Not_Mandated: "Non Mandaté",
    Details: "Détails",
    Join: "Rejoindre",
    Replay: "Rejouer",
    Purchase: "Acheter",
    "Possible to review the training for max 15 days after the date of the live":
      "Possible de revoir la formation pendant max 15 jours après la date du live",
    Webinar: "Webinar",
    "In progress": "En cours",
    "Certificate included approved by": "Attestation incluse agréé par",
    "En Live": "En Live",
    see_version: "Voir version",
    atText: "à",
    publishedOn: "Publié le",
    reading: "Lecture de",
    noOptions: "aucune options",
    sharedWith: "partager avec",
    share: "partager",
    "En Replay": "En Replay",
    add: "Ajouter",
    quote_text: "Insérer le texte de la citation",
    quote_author: "Insérer l'auteur de la citation",
    write_here: "Écrire ici ...",
    customize: "Personnaliser",
    customize_dynamic_fields: "Personnalisez avec des champs dynamiques",
    quiz: "Questionnaire",
    save: "Enregistrer",
  },
  nl: {
    ARTCILES: "Artikelen",
    Official: "Officieel",
    Manager: "Manager",
    "Legal Reprentative": "Wettelijke vertegenwoordiger",
    "Organization roles": "organisatie rollen",
    "Blog roles": "blog rollen",
    "Editor-in-chief": "Hoofdredacteur",
    CHIEF_EDITOR: "Hoofdredacteur",
    AUTHOR: "Auteur",
    REDACTOR: "Redacteur",
    LEGAL_REPRESENTATIVE: "WETTELIJKE VERTEGENWOORDIGER",
    MANAGER: "MANAGER",
    OFFICIAL: "OFFICIEEL",
    SHAREHOLDER: "AANDEELHOUDER",
    QUALITY_MANAGER: "KWALITEITSMANAGER",
    EXTERNAL: "EXTERNE",
    Mandated: "gemandateerde",
    Not_Mandated: "niet Gemandateerde",
    Details: "Details",
    Join: "Meedoen",
    Replay: "Herhaling",
    Purchase: "Aankoop",
    "Possible to review the training for max 15 days after the date of the live":
      "Mogelijkheid om de training te bekijken tot 15 dagen vanaf de datum van de live",
    Webinar: "Webinar",
    "In progress": "Bezig",
    "Certificate included approved by":
      "Certificaat meegeleverd goedgekeurd door",
    "En Live": "Live",
    see_version: "Zie versie",
    atText: "bij",
    publishedOn: "Gepubliceerd op",
    reading: "Lezen",
    noOptions: "[no options]",
    sharedWith: "[share with]",
    share: "[share]",
    "En Replay": "En Replay",
    add: "Toevoegen",
    quote_text: "Citaattekst invoegen",
    quote_author: "Voeg de auteur van de bronvermelding in",
    write_here: "Schrijf hier ...",
    customize: "Aanpassen",
    customize_dynamic_fields: "Aanpassen met dynamische velden",
    quiz: "Quiz",
    save: "Opslaan",
  },
};
